































import Confirmacao from '@/components/ui/Confirmacao.vue';
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue';
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import DialogoDeEdicaoDePromocao from '@/components/promocoes/DialogoDeEdicaoDePromocao.vue';
import { DataOptions } from 'vuetify';
import axios, { CancelTokenSource } from 'axios';
import { Promocao } from '@/models/venda';
import { FindPromocaoUseCase } from '@/usecases/venda/FindPromocaoUseCase';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { dateToPtBrFormat } from '@/shareds/date/date-utils';

@Component({
	components: {
		DataTableDeCrud,
		Confirmacao,
		DialogoDeEdicaoDePromocao,
	},
})
export default class TelaDePromocoes extends Vue {
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDePromocao

	promocoes: Promocao[] = []
	promocao: Promocao | null = null
	findPromocaoUseCase = new FindPromocaoUseCase()

	totalRegistros = -1
	carregando = false
	mostrar = false
	busca = ''
	editando = true
	cancelToken: CancelTokenSource | null = null
	mostrarDialogoDeEdicao = false
	dateToPtBrFormat = dateToPtBrFormat

	headers = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'Data Inicio', value: 'dataInicio' },
		{ text: 'Data Fim', value: 'dataFim' },
		{ text: 'Tipo de Promoção', value: 'tipoDePromocao' },
	]

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	created() {
		this.buscar()
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()

			const params = {
				page: this.paginacao.page - 1,
				busca: this.busca || undefined,
				size: this.paginacao.itemsPerPage,
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findPromocaoUseCase.findPagePromocoes(params, axiosConfig)
			this.totalRegistros = page.totalElements
			this.promocoes = page.content
			this.carregando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	abrirDialogoDeCriarPromocao() {
		this.editando = false
		const promocao = criarPromocao()
		this.dialogoDeEdicao.mostrar(promocao, true)
	}

	abrirDialogoDePromocao(indice: any) {
		this.promocao = this.promocoes[indice]
		this.editando = true
		this.dialogoDeEdicao.mostrar(this.promocao, false)
	}

	get itensFormatados() {
		return this.promocoes.map(promocao => ({
			...promocao,
			dataInicio: dateToPtBrFormat(promocao.dataInicio),
			dataFim: dateToPtBrFormat(promocao.dataFim),
		}))
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar

	@Watch('busca')
	onChangeBusca() {
		this.paginacao.page = 1
		this.buscar()
	}

	@Watch('dialogoDeEdicao.mostra')
	onDialogoFechado() {
		if (!this.dialogoDeEdicao.mostra) {
			this.buscar()
		}
	}

	atualizarPromocao(promocaoAtualizada: Promocao) {
		const index = this.promocoes.findIndex(p => p.id === promocaoAtualizada.id);
		if (index !== -1) {
			this.promocoes.splice(index, 1, promocaoAtualizada);
		}
	}
}

export function criarPromocao () {
	const promocao: Promocao = {
		id: '',
		nome: '',
		descricao: '',
		ativa: false,
		tipoDePromocao: '',
		dataInicio: new Date().toISOString().split('T')[0],
		dataFim: new Date().toISOString().split('T')[0],
		todosOsProdutos: false,
		beneficio: '',
		aplicarPorItem: false,
		acumulativa: false,
		limitePorCliente: 0,
		limiteTotal: 0,
		descontoMax: 0,
		aplicavelUmaVezPorDia: false,
		aplicavelUmaVezPorMes: false,
		tags: [],
		categorias: [],
		marcas: [],
		skus: [],
		estacoes: [],
		generos: [],
		lojas: [],
		tiposDeCliente: [],
		regrasDeAplicacaoPromocao: [],
		promocoesDescontoProgressivo: [],
	}
	return promocao
}
